import React from "react";

import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import {
  MATERIALS_URL,
  DELETE_MATERIAL,
  SAVE_MATERIAL,
} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function MaterialsListing() {
  const attributes = [
    { key: "materialName", label: "Material Name", flex: 2 },
  ];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);
  return (
    <GenericItemsListing
      items_URL={MATERIALS_URL}
      SAVE_Item={SAVE_MATERIAL}
      DELETE_Item={DELETE_MATERIAL}
      title="Materials"
      name="Material"
      icon={<AddShoppingCartRoundedIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
        uniqueId={"materialId"}
    />
  );
}

export default MaterialsListing;
